export default class MarketPlace {
	constructor(appName, newGamesUrl = undefined) {
		this.appName = appName;
		this.games =
			[
				{
					"name": "Spades",
					"FBInstant": "1076879022772932",
					"ios": "itms-apps://itunes.apple.com/app/id6458878117",
					"android": "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.spades",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9NN5MHQV0NFV",
					"windows": "https://www.microsoft.com/store/apps/9NN5MHQV0NFV",
					"web": "https://cardsjd.com/spades"
				},
				{
					"name": "Hearts",
					"FBInstant": "1388261732063000",
					"ios": "itms-apps://itunes.apple.com/app/id6476223216",
					"android": "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.hearts",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9NCRQB9643L7",
					"windows": "https://www.microsoft.com/store/apps/9NCRQB9643L7",
					"web": "https://cardsjd.com/hearts/"
				},
				{
					"name": "GinRummy",
					"FBInstant": "1150157359290701",
					"ios": "itms-apps://itunes.apple.com/app/id6470861992",
					"android": "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.ginrummy",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9P5NP9RMRQQ6",
					"windows": "https://www.microsoft.com/store/apps/9P5NP9RMRQQ6",
					"web": "https://cardsjd.com/ginrummy/"
				},
				{
					"name": "Cribbage",
					"FBInstant": "1264960130273679",
					"ios": "itms-apps://itunes.apple.com/app/id1362318446",
					"android": "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.cribbage",
					"windows": "https://www.microsoft.com/store/apps/9NTJ99B0PBLJ",
					"windowsStoreProtocoLink": "https://www.microsoft.com/store/apps/9NTJ99B0PBLJ",
					"web": "https://cardsjd.com/cribbage/",
					"amazon": "amzn://apps/android?asin=B07BMRYW6D"
				},
				{
					"name": "Speed",
					"FBInstant": "401658098090396",
					"ios": "itms-apps://itunes.apple.com/app/id914247866",
					"android": "https://play.google.com/store/apps/details?id=com.jimmyinteractive.speed",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9WZDNCRFJ2SB",
					"windows": "https://www.microsoft.com/store/apps/9WZDNCRFJ2SB",
					"web": "https://cardsjd.com/speed/"
				},
				{
					"name": "Nertz",
					"FBInstant": "",
					"ios": "itms-apps://itunes.apple.com/app/id1089058813",
					"android": "https://play.google.com/store/apps/details?id=com.jimmyinteractive.nertz",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9WZDNCRCWPPB",
					"windows": "https://www.microsoft.com/store/apps/9WZDNCRCWPPB",
					"web": "https://cardsjd.com/nertz/"
				},
				{
					"name": "Solitaire",
					"FBInstant": "",
					"ios": "itms-apps://itunes.apple.com/app/id1042411982",
					"android": "https://play.google.com/store/apps/details?id=com.jimmyinteractive.solitaire",
					"windowsStoreProtocoLink": "ms-windows-store://pdp/?productid=9WZDNCRDKJTJ",
					"windows": "https://www.microsoft.com/store/apps/9WZDNCRDKJTJ",
					"web": "https://cardsjd.com/solitaire/"
				},
				{
					"name": "Minesweeper",
					"FBInstant": "",
					"ios": "https://itunes.apple.com/us/app/minesweeper-classic-mine-sweeper/id1163024893?mt=8",
					"android": "https://play.google.com/store/apps/details?id=com.jimmyinteractive.minesweeper",
					"windowsStoreProtocoLink": "",
					"windows": "https://cardsjd.com/minesweeper/",
					"web": "https://cardsjd.com/minesweeper/"
				}
			];

		if (newGamesUrl) {
			this.fetchUpdatedList(newGamesUrl);
		}
	}

	async fetchUpdatedList(newGamesUrl) {
		try {
			const response = await fetch(newGamesUrl);
			const games = await response.json();
			if (games && games.length > 0) {
				this.games = games;
			}
		} catch (err) {
			console.log('Error fetching updated games list, squleching', err);
		}

	}

	hasGames(osOverride) {
		const hasGame = this.getGames(osOverride).length > 0;
		return hasGame;
	}

	getGames(osOverride) {
		const os = osOverride || this.getOS();
		const games = this.games.filter(game => {
			return game[os] && game.name !== this.appName;
		});
		return games;
	}

	async switchGameAsync(id) {
		if (typeof globalThis.FBInstant === 'undefined') {
			return Promise.resolve(false);
		}

		return globalThis.FBInstant.switchGameAsync(id);
	}

	show(appName, osOverride) {
		const os = osOverride || this.getOS();
		const games = this.games.filter(game => {
			return game[os] && game.name === appName;
		});

		if (games.length > 0) {
			const game = games[0];

			if (os === 'FBInstant') {
				this.switchGameAsync(game.FBInstant).catch(function (e) {
					console.log('fBInstantGame.switchGameAsync: Error: ' + JSON.stringify(e));// Handle game change failure
				});
			} else {
				window.open(game[os], '_system');
			}
		}
	}

	getOS() {
		const ua = navigator.userAgent;
		const isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

		if (typeof FBInstant !== 'undefined') {
			if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
				return 'FBInstantiOS'; //used to not show more games on fb ios
			} else {
				return 'FBInstant';
			}
		}

		if (/(android)/i.test(navigator.userAgent) && isKindle) {
			return 'amazon';
		}
		if (/(android)/i.test(navigator.userAgent) && !isKindle) {
			return 'android';
		}
		if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
			return 'ios';
		}
		if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
			// Windows 10 UWP
			return 'windows';
		}
		//pwa + edg = Edge
		const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
		if (isInStandaloneMode && /(Edg)/i.test(navigator.userAgent)) {
			return 'windows';
		}

		return "web";
	}
}
